// Nav + footer for the PRERENDERED raisedbeef.com pages (the gate homepage and
// the solutions page).
//
// Separate from RbSiteChrome, which the SPA pages use, for one reason: these
// documents do not mount a react-router Router, so a <Link> here would push
// history and render nothing. Every link is a plain <a>, which is correct
// anyway — each destination is a full page load into a different bundle.
//
// Link data still comes from rbNavLinks.ts, the same array RbNav and
// RbMobileMenu read, so the menus cannot drift apart.
//
// SSR rules apply to everything in this file: no window/document/localStorage
// at module scope or during render.

import { useState } from "react";

import { NAV_LINKS, type RbNavKey } from "./rbNavLinks";

export function StaticNav({ active }: { active?: RbNavKey }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="nav">
      <div className="wrap">
        <a className="brand" href="/" aria-label="RaisedBeef home">
          <img src="/brand/raisedbeef-wordmark.png" alt="RaisedBeef" className="brandlogo" />
        </a>

        <nav className="navlinks">
          {NAV_LINKS.filter((l) => l.inNav).map((l) =>
            l.key === active ? (
              <span key={l.key} className="on" aria-current="page">
                {l.label}
                {l.pro && <span className="pro">PRO</span>}
              </span>
            ) : (
              <a key={l.key} href={l.path()}>
                {l.label}
                {l.pro && <span className="pro">PRO</span>}
              </a>
            ),
          )}
        </nav>

        <div className="navcta">
          {/* Two doors, deliberately. /auth is the Market Intelligence
              platform; /my-barn/login is the barn product (Sale Barn App +
              My Barn desktop), which a barn buys and which never leads into
              the platform. Owner decision 2026-08-16. */}
          <a href="/auth" className="ghost">Sign in</a>
          {/* Two labels, one shown at a time by CSS: the full one on desktop,
              "USDA" on phones where the header cannot hold it. aria-label
              keeps the full name for screen readers at every width. */}
          <a href="/markets" className="btn-usda" aria-label="USDA Reports">
            <span className="lblfull">USDA Reports</span>
            <span className="lblshort">USDA</span>
          </a>
          <a href="/dvauction-live" className="btn">Live sales</a>
          <div className="mnav">
            <button
              type="button"
              className="mnavbtn"
              aria-label={open ? "Close menu" : "Open menu"}
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
            >
              <span className="mnavicon" aria-hidden="true">{open ? "✕" : "☰"}</span>
            </button>
            {open && (
              <>
                <div className="mnavback" onClick={() => setOpen(false)} />
                <div className="mnavpanel" onClick={() => setOpen(false)}>
                  {NAV_LINKS.map((l) => (
                    <a key={l.key} href={l.path()}>{l.mobileLabel ?? l.label}</a>
                  ))}
                  <a href="/solutions">Data &amp; Workflow Solutions</a>
                  <a href="/auth">Sign in</a>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function StaticFooter() {
  return (
    <footer>
      <div className="wrap">
        <img src="/brand/raisedbeef-wordmark.png" alt="RaisedBeef" className="brandlogo footlogo" />
        <nav className="fl">
          <a href="/dvauction-live">DVAuction Live Sales</a>
          <a href="/markets">USDA Reports</a>
          <a href="/sales">Sale Calendar</a>
          <a href="/leaderboard">Leaderboard</a>
          <a href="/platform">Platform</a>
          <a href="/solutions">Solutions</a>
          <a href="/support">Support</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
        </nav>
        <div className="pb">Powered by USDA + DVAuction · © 2026</div>
      </div>
    </footer>
  );
}
